import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import featureFlags from '../config/featureFlags';

export const MiniCTA = () => {
  const scrollToSection = (id) => {
    const element = document.querySelector(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section
      className="py-20 bg-gradient-to-br from-teal-600 to-teal-700 relative overflow-hidden"
      data-testid="mini-cta-section"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
          <Sparkles className="w-4 h-4 text-teal-200" />
          <span className="text-sm font-medium text-teal-100">Jetzt Projekt starten</span>
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6">
          Bereit für mehr Sichtbarkeit?
        </h2>
        <p className="text-lg text-teal-100 mb-10 max-w-2xl mx-auto">
          Lassen Sie uns gemeinsam Ihr Projekt umsetzen – von der Fahrzeugbeklebung bis zum individuellen Sticker.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={() => scrollToSection('#kontakt')}
            className="bg-white text-teal-700 hover:bg-teal-50 rounded-full px-8 py-6 text-base font-semibold shadow-lg transition-all"
            data-testid="mini-cta-primary"
          >
            Angebot anfragen
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
          {featureFlags.SHOP_ENABLED && (
            <Button
              onClick={() => scrollToSection('#sticker')}
              variant="outline"
              className="bg-transparent border-2 border-white/30 text-white hover:bg-white/10 rounded-full px-8 py-6 text-base font-semibold transition-all"
              data-testid="mini-cta-secondary"
            >
              Sticker bestellen
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};
